import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import style from "./style.module.scss";
import Invoice from "../../CrossReference/Forms/Invoice";

const ModalInvoice = ({ open, toggle, invoiceInfo }) => (
  <Modal isOpen={open} toggle={toggle} className={style.modal} invoiceInfo={invoiceInfo}>
    <ModalHeader toggle={toggle}>View Invoice</ModalHeader>
    <ModalBody className={style.body}>
      <Invoice invoiceInfo={invoiceInfo} />
    </ModalBody>
    <ModalFooter />
  </Modal>
);

export default ModalInvoice;
